export function changeAddressSelected() {
  jQuery(
    ".woocommerce-checkout .list-address-options .single-address-option"
  ).on("click", function () {
    const option = jQuery(this);
    const data = option.data();
    option.addClass("selected").siblings().removeClass("selected default");

    const resume = jQuery(".white-card-address");

    resume.find(".person-name").text(data.full_name);
    resume.find(".person-phone").text(data.phone);

    // monta linha 1
    let line1 = data.address_1;
    if (data.address_2) line1 += ", " + data.address_2;
    if (data.district) line1 += ", " + data.district;
    if (data.city) line1 += " – " + data.city;
    resume.find(".address-line1").text(line1);

    // altera o state com base no que foi clicado
    resume.attr("data-state", data.state);
    // linha 2
    resume.find(".address-line2").text(data.eircode + ", Irlanda");

    // instruções
    if (data.instructions) {
      resume
        .find(".delivery-instructions")
        .text("Instruções de entrega: " + data.instructions)
        .show();
    } else {
      resume.find(".delivery-instructions").hide();
    }
    resume.attr("data-state", data.state);
    resume.data("state", data.state);
  });

  jQuery(document).on(
    "click",
    ".step-2 button.confirmarEndereco",
    function (e) {
      e.preventDefault();

      const selected = jQuery(
        ".list-address-options .single-address-option.selected"
      );
      if (!selected.length) {
        alert("Por favor, selecione um endereço antes de continuar.");
        return;
      }

      const state = selected.data("state");
      const $list = jQuery(".list-shipping-options");

      $.ajax({
        url: my_ajax_object.ajax_url,
        method: "POST",
        dataType: "json",
        data: {
          action: "get_shipping_methods_by_region",
          state: state,
        },
        beforeSend() {
          $list.html(
            '<div class="loading">Carregando opções de entrega…</div>'
          );
        },
        success(resp) {
          if (resp.success) {
            // substitui pelo HTML retornado
            $list.html(resp.data.html);
            jQuery(".single-step.step-2").removeClass("active");
            jQuery(".single-step.step-3").addClass("active");
          } else {
            alert(resp.data.message);
            $list.empty();
          }
        },
        error() {
          alert("Ocorreu um erro ao carregar as opções de entrega.");
          $list.empty();
        },
      });
    }
  );

  jQuery(document).on("click", ".single-shipping-option", function () {
    const $opt = jQuery(this);
    const rateId = $opt.data("rateId") || $opt.attr("data-rate-id");

    const selectedAddr = jQuery(
      ".list-address-options .single-address-option.selected"
    );
    const state = selectedAddr.data("state");
    const eircode = selectedAddr.data("eircode");
    jQuery.post(
      my_ajax_object.ajax_url,
      {
        action: "get_updated_total",
        rate_id: rateId,
        state: state,
        eircode: eircode.replace(/\s+/g, ""),
      },
      function (resp) {
        if (resp.success) {
          // injeta o total formatado (incluindo €) no elemento
          jQuery(".valueTotal").html(resp.data.total_html);
          console.log(
            "Frete aplicado:",
            rateId,
            "| State:",
            state,
            "| Eircode:",
            eircode,
            "| Total:",
            resp.data.total_html
          );
        } else {
          console.error("Erro ao atualizar total:", resp.data.message);
        }
      },
      "json"
    );
  });
}
